import { MenuItemsModel } from '@core/menu/menu.model';
import { RouteEntity } from '@core/router/route.entity';
import { PrivilegesModules } from '@core/privileges/privileges-modules';
import { marker } from '@colsen1991/ngx-translate-extract-marker';


export const submenu: MenuItemsModel[] = [
    {
        mdId: 1,
        mdName: marker('modules.agents.head'),
        url: RouteEntity.Root + RouteEntity.Agents,
        objName: [PrivilegesModules.AgentsAgents],
    },
    {
        mdId: 2,
        mdName: marker('modules.orders.head'),
        url: RouteEntity.Root + RouteEntity.Orders,
        objName: [PrivilegesModules.AgentsOrders],
    },
];
